import {
	permissionList,
	merchantPermissionSet,
	merchantRiskPermissionSet,
	attachmentPermissionSet,
	hasPermissions,
} from "helpers";

export const getMerchantTabs = () => [
	{
		path: "general",
		name: "General",
		requiredPermissions: merchantPermissionSet,
	},
	{
		path: "ach-processor",
		name: "ACH Processor",
		requiredPermissions: merchantPermissionSet,
	},
	{
		path: "results",
		name: "U / W Results",
		requiredPermissions: merchantPermissionSet,
	},
	{
		path: "risk",
		name: "Risk",
		requiredPermissions: merchantRiskPermissionSet,
	},
	{
		path: "terminal",
		name: "Terminal",
		requiredPermissions: permissionList.ManualMerchantEntry,
	},
	{
		path: "batch-history",
		name: "Batch History",
		requiredPermissions: permissionList.ViewBatchHistory,
	},
	{
		path: "deposits",
		name: "Deposits",
		requiredPermissions: permissionList.ViewDepositHistory,
	},
	{
		path: "statement",
		name: "Statement",
		requiredPermissions: permissionList.ViewStatements,
	},
	{
		path: "chargebacks",
		name: "Chargebacks / Retrievals",
		requiredPermissions: permissionList.ViewChargebacks,
	},
	{
		path: "fees",
		name: "Fees",
		requiredPermissions: merchantPermissionSet,
	},
	{
		path: "billing-information",
		name: "Billing Information",
		requiredPermissions: merchantPermissionSet,
	},
	{
		path: "additional-services",
		name: "Additional Services",
		requiredPermissions: merchantPermissionSet,
	},
	{
		path: "attachments",
		name: "Attachments",
		requiredPermissions: attachmentPermissionSet,
	},
	{
		path: "notes",
		name: "Notes",
		requiredPermissions: permissionList.ViewAccountNotes,
	},
	{
		path: "pend-details",
		name: "Pend Details",
		requiredPermissions: merchantPermissionSet,
	},
	{
		path: "residuals",
		name: "Residuals",
	},
	{
		path: "history",
		name: "History",
		requiredPermissions: merchantPermissionSet,
	},
	/*{
		 implementation in RC-4599 
	},*/
	// {
	// 	path: "change-log",
	// 	name: "Change Log",
	// },
];

export const getMerchantTabsPaths = () =>
	getMerchantTabs()
		.filter(tab => hasPermissions(tab.requiredPermissions) && !tab.isHidden)
		.map(tab => tab.path);
